import React, { ReactNode, useLayoutEffect } from 'react';

import { THEME_TYPES, ThemeProvider } from '@infoods/lifebase-ui';
import { ErrorBoundary } from 'react-error-boundary';
import { getService } from 'react-in-angularjs';

import { ErrorFallback } from '../../components/ErrorFallback/ErrorFallback';
import { usePageConfig } from '../../hooks/usePageConfig';

type SystemProvidersProps = {
  children: ReactNode;
};

const SystemProviders = ({ children }: SystemProvidersProps) => {
  const { theme: pageTheme } = usePageConfig();

  const currentTheme = pageTheme ?? THEME_TYPES.SWYMO;

  // Sync theme to Angular Material
  useLayoutEffect(() => {
    const $rootScope = getService('$rootScope');

    $rootScope.setTheme(currentTheme);
  }, [currentTheme]);

  return (
    <ThemeProvider theme={currentTheme}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
    </ThemeProvider>
  );
};

export { SystemProviders };
